export const powerformErrorCodes = {
  INACTIVE: 'inactive',
  IRRETRIEVABLE_RECIPIENT: 'irretrievable_recipient',
  NOT_FOUND: 'powerform_not_found',
  NO_FREEFORM: 'powerform_freeform_signing_not_allowed',
  TOO_MANY_REQUESTS: 'too_many_requests'
}
